import { Params } from '@angular/router';
import {
  FilterBarField,
  SelectedFilterField,
} from '@cdw-ae/filter-bar-interfaces';
import {
  NavigationConfig,
  UrlStateConfig,
  UrlStateItem,
} from '@cdw-ae/url-params';
import { createAction, props } from '@ngrx/store';

// URL-related actions
export const loadFiltersFromUrl = createAction(
  '[Filter] Load Filters From URL',
  props<{ queryParams: Params }>()
);

export const updateFilters = createAction(
  '[Filter] Update Filters',
  props<{
    filters?: SelectedFilterField[];
    filterBarId?: string;
    identifier?: string;
    clickedValue?: string;
  }>()
);

export const loadFiltersFromUrlSuccess = createAction(
  '[Filter] Load Filters From URL Success',
  props<{
    filterBars: { [filterBarId: string]: SelectedFilterField[] };
    filterBarId?: string;
    // EDUS-2575: when restoring a shared `?filterSnapshotRef` link, carry the
    // ref(s) so the reducer seeds state and the grid queries by ref.
    filterSnapshotRefs?: { [filterBarId: string]: string | null };
  }>()
);
export const updateFiltersSuccess = createAction(
  '[Filter] Update Filters Success',
  props<{
    filters?: SelectedFilterField[];
    filterBarId?: string;
    identifier?: string;
    clickedValue?: string;
  }>()
);

// set up all configs at once
export const setRouteConfig = createAction(
  '[Filter] Set Route Config',
  props<{
    filterBarSettings?: FilterBarField[];
    urlParamConfig?: UrlStateConfig;
    navigationConfig?: NavigationConfig<UrlStateItem>[];
  }>()
);

export const setFilterBarSettings = createAction(
  '[Filter] Set Filter Bar Settings',
  props<{ settings: FilterBarField[] }>()
);

export const setCurrentUrlParamConfig = createAction(
  '[Filter] Set Current Config',
  props<{ config: UrlStateConfig }>()
);

export const setNavigationConfig = createAction(
  '[Filter] Set Navigation Config',
  props<{ navigationConfig: NavigationConfig<UrlStateItem>[] }>()
);

// Clear filters action
export const clearFilters = createAction(
  '[Filter] Clear Filters',
  props<{ filterBarId?: string }>()
);

// EDUS-2575: set (or clear, with null) the content-addressed filter-snapshot
// reference for a filter bar. Produced by the data-fetch path on overflow and
// by restore-on-load; the URL-sync effect reads it.
export const setFilterSnapshotRef = createAction(
  '[Filter] Set Filter Snapshot Ref',
  props<{ filterBarId?: string; snapshotRef: string | null }>()
);
